import $ from 'jquery'
import { formEvent, formFieldChangeEvent } from 'application/ga_form_event'
import { trim } from 'lodash'

SOPHIA.formGA = function (form, event) {
  const step = form.data('formStep')
  const steps = form.data('formSteps')

  const gaDataForm = {
    event: event,
    form_name: form.data('formName'),
    form_type: form.data('formType') || form.data('formName'),
    form_page: trim($('meta[property="og:title"]').attr('content'))
  }

  if (event == 'form_progress') {
    // GA Form Progress Event
    gaDataForm.form_step = step
    gaDataForm.event_detail = parseFloat(step/steps).toFixed(2) * 100 + '%'
    formEvent(gaDataForm)
  } else if (event == 'form_submit') { // if we call form_submit for customised forms
    onSubmitForm(gaDataForm, step, steps)
  } else if (event == 'form_view') {
    // GA Form View Event
    if (step && step == 1 || !step) {
      formEvent(gaDataForm) // send GA event form_view only for the 1st step or if no steps (ordinary forms)
    }

    onFieldChange(form, gaDataForm)
  }
}

$(document).ready(() => {
  if ($('form[data-form-name]:not([data-form-overlay])').length) {
    SOPHIA.formGA($('form[data-form-name]:not([data-form-overlay])'), 'form_view'); // do not track if the form is hidden
  }
})

function onFieldChange(form, gaDataForm) {
  let isFormStarted = false // to track only once
  const step = form.data('formStep')

  $('input, textarea, select', $(form)).one('change keypress paste textInput input', () => {
    if (!isFormStarted) {
      gaDataForm.event = 'form_start'
      formEvent(gaDataForm)
      isFormStarted = true
    }
  })

  $('input, textarea, select', $(form)).off('change.form').on('change.form', (e) => {
    const $formEl = $(e.target)

    if (step) {
      gaDataForm.form_step = step
    }

    gaDataForm.event = 'form_field_change'

    let fieldValue,
        pii_field = (gaDataForm.form_type == 'complete_profile' && step && step == 1 && $formEl.parents('.flexible-sso-completion__name-block').length == 0) ||
                    $formEl.attr('type') == 'password'

    if (e.target.tagName == 'SELECT') {
      fieldValue = $formEl.find(':selected').text()
      gaDataForm.field_type = 'dropdown'
    } else if (e.target.tagName == 'TEXTAREA') {
      gaDataForm.field_type = 'textarea'
      fieldValue = $formEl.val()
    } else {
      gaDataForm.field_type = $formEl.attr('type')
      fieldValue = $formEl.val()
    }

    if (pii_field) { // for passwords, addresses etc. (except first/last name and email)
      gaDataForm.field_value = 'PII value'
    } else {
      gaDataForm.field_value = fieldValue
    }

    if (gaDataForm.field_type == 'email') {
      gaDataForm.field_name = 'email_address'
    } else {
      gaDataForm.field_name = $formEl.data('field-name') || $formEl.attr('name') || $formEl.attr('id')
    }

    formFieldChangeEvent(gaDataForm)
  })
}

function onSubmitForm(gaDataForm, step, steps) {
  if (!step || (step && step == steps)) {
    if (step) {
      delete gaDataForm.form_step
      delete gaDataForm.event_detail
    }

    gaDataForm.event = 'form_submit'
    formEvent(gaDataForm)
  }
}
